import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import axiosClient from "../../config/axiosClient";
import API_ENDPOINTS from "../../config/api";

const MenuModal = ({ show, onClose, onSave, initialData }) => {
  const [menus, setMenus] = useState([]);
  const [formData, setFormData] = useState({
    id: 0,
    title: "",
    url: "",
    icon: "fa-folder", // Default icon
    order: 0,
    parentId: "", // String empty để làm giá trị mặc định cho "Root"
    isActive: true
  });

  useEffect(() => {
    // Lấy danh sách menu để làm Dropdown ParentId
    const fetchAllMenus = async () => {
      try {
        const res = await axiosClient.get(API_ENDPOINTS.menus);
        setMenus(res.data || []);
      } catch (err) { console.error("Error fetching menus:", err); }
    };
    fetchAllMenus();

    if (initialData) {
      setFormData({
        id: initialData.id || 0,
        title: initialData.title || "",
        url: initialData.url || "",
        icon: initialData.icon || "fa-folder",
        order: initialData.order || 0,
        parentId: initialData.parentId || "",
        isActive: initialData.isActive !== undefined ? initialData.isActive : true
      });
    }
  }, [initialData, show]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : (name === "parentId" && value === "" ? null : value)
    }));
  };

// Cập nhật hàm handleSubmit trong MenuModal.jsx
const handleSubmit = async (e) => {
  e.preventDefault();
  
  const dataToSave = { 
    ...formData, 
    parentId: formData.parentId === "" ? null : parseInt(formData.parentId),
    order: parseInt(formData.order)
  };

  try {
    if (initialData && initialData.id) {
      // SỬA (PUT)
      await axiosClient.put(`${API_ENDPOINTS.menus}/${initialData.id}`, dataToSave);
    } else {
      // THÊM (POST)
      await axiosClient.post(API_ENDPOINTS.menus, dataToSave);
    }
    onSave(); // Gọi lại hàm reload danh sách từ parent component
    onClose();
  } catch (err) {
    console.error("Error saving menu:", err);
    alert("Có lỗi xảy ra khi lưu!");
  }
};

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton className="bg-primary text-white">
        <Modal.Title className="small fw-bold">{initialData ? "Edit Menu" : "Add New Menu"}</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group className="mb-2">
            <Form.Label className="small fw-bold">Title</Form.Label>
            <Form.Control name="title" value={formData.title} onChange={handleChange} required />
          </Form.Group>

          <div className="row">
            <div className="col-md-6">
              <Form.Group className="mb-2">
                <Form.Label className="small fw-bold">URL</Form.Label>
                <Form.Control name="url" value={formData.url} onChange={handleChange} placeholder="/path" />
              </Form.Group>
            </div>
            <div className="col-md-6">
              <Form.Group className="mb-2">
                <Form.Label className="small fw-bold">Icon (FontAwesome)</Form.Label>
                <Form.Control name="icon" value={formData.icon} onChange={handleChange} />
              </Form.Group>
            </div>
          </div>

          <Form.Group className="mb-2">
            <Form.Label className="small fw-bold">Parent Menu</Form.Label>
            <Form.Select name="parentId" value={formData.parentId || ""} onChange={handleChange}>
              <option value="">-- This is a Root Menu --</option>
              {menus.filter(m => m.id !== formData.id).map(m => (
                <option key={m.id} value={m.id}>{m.title}</option>
              ))}
            </Form.Select>
          </Form.Group>

          <div className="row">
            <div className="col-md-6">
              <Form.Group className="mb-2">
                <Form.Label className="small fw-bold">Order</Form.Label>
                <Form.Control type="number" name="order" value={formData.order} onChange={handleChange} />
              </Form.Group>
            </div>
            <div className="col-md-6 d-flex align-items-end mb-2">
              <Form.Check type="checkbox" name="isActive" label="Is Active" checked={formData.isActive} onChange={handleChange} />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onClose}>Close</Button>
          <Button variant="primary" type="submit">Save Menu</Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default MenuModal;